/**
 * DEFTER BULUNAMADI — `DEFTER_KAYIP`. Kayıt (profil) var ama şifreli kap
 * okunamadı: tarayıcı depolamayı temizlemiş ya da dosyalar bozulmuş olabilir.
 * Boş bir defter UYDURULMAZ; çıkış yolu kullanıcının açık onayıyla boş
 * defterle başlayıp buluttan geri yüklemek.
 */

import { M } from "../../dil";
import { useState } from "react";
import type { LocalRepository } from "@parafon/contracts/local-api";
import { errorDetail, errorText } from "../../lib/rpcError";
import { useMutation } from "../../repo/useAsync";
import { Button, InlineError, Notice } from "../../ui/primitives";

export function DefterKayipEkrani({
  repo,
  error,
  onDevam,
}: {
  readonly repo: LocalRepository;
  readonly error: unknown;
  readonly onDevam: () => void;
}) {
  const [emin, setEmin] = useState(false);
  const run = useMutation();
  const kilit = repo.kilit;
  const detay = errorDetail(error);
  return (
    <main className="mx-auto flex min-h-dvh max-w-xl flex-col justify-center p-6">
      <div className="pf-card space-y-4 p-5">
        <h1 className="text-[18px] font-semibold text-ink">{M.kilit.kayip.baslik}</h1>
        <p className="text-[13px] leading-relaxed text-ink">{errorText(error)}</p>
        <Notice tone="warn" title={M.kilit.kayip.neOlmus}>
          <p>{M.kilit.kayip.neOlmusMetin}</p>
        </Notice>
        {kilit !== undefined &&
          (!emin ? (
            <Button variant="primary" onClick={() => setEmin(true)}>
              {M.kilit.kayip.bosKasaylaBasla}
            </Button>
          ) : (
            <div className="space-y-2">
              <p className="text-[13px] text-ink">{M.kilit.kayip.bosKasaAciklama}</p>
              <div className="flex flex-wrap gap-2">
                <Button
                  variant="primary"
                  disabled={run.pending}
                  onClick={() =>
                    void run.run(async () => {
                      await kilit.bosDefterleBasla();
                      onDevam();
                    })
                  }
                >
                  {M.kilit.kayip.evetBasla}
                </Button>
                <Button onClick={() => setEmin(false)}>{M.ortak.vazgec}</Button>
              </div>
            </div>
          ))}
        {run.error !== undefined && <InlineError error={run.error} />}
        {detay !== undefined && (
          <details>
            <summary className="cursor-pointer text-[12px] text-muted">{M.ortak.teknikAyrinti}</summary>
            <pre className="mt-1 whitespace-pre-wrap text-[11px] text-muted">{detay}</pre>
          </details>
        )}
      </div>
    </main>
  );
}
